import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'cart-reset-warning-modal',
  templateUrl: './cart-reset-warning-modal.component.html',
  styleUrls: ['./cart-reset-warning-modal.component.scss']
})
export class CartResetWarningModalComponent {
  constructor(public modal: NgbActiveModal) {
  }
}
